<button
	mat-button
	type="button"
	*ngIf="alwaysShow || hasLogs"
	(click)="openLog($event)"
	[class.small]="small"
	class="log-button">
	<img class="log" src="assets/images/log2.svg" alt="View log">
</button>
